/**
 * Shared Authentication Headers Utility
 * 
 * This utility provides a unified way to get auth headers for API calls.
 * Uses Supabase-only authentication.
 * 
 * IMPORTANT: All authentication now goes through Supabase.
 */
import supabase from './supabase';

/**
 * Get authentication headers for API calls
 * Gets token from Supabase session only
 * 
 * @returns {Promise<{Authorization?: string}>} Headers object with Authorization if authenticated
 */
export const getAuthHeaders = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      return { Authorization: `Bearer ${session.access_token}` };
    }
  } catch (e) {
    console.log('[Auth] Error getting Supabase session:', e.message);
  }
  
  return {};
};

/**
 * Synchronous version - DEPRECATED
 * This function is kept for backward compatibility but will always return empty headers.
 * Use getAuthHeaders() (async) instead.
 * 
 * @deprecated Use getAuthHeaders() instead
 */
export const getAuthHeadersSync = () => {
  console.warn('[Auth] getAuthHeadersSync is deprecated. Use async getAuthHeaders() instead.');
  return {};
};

export default getAuthHeaders;
